import React, { useState, useRef, useEffect } from "react";

const CategoryDropdown = ({ categories, selected, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const placeholderText = selected.length
    ? selected.join(", ")
    : "Select plastic categories";

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="category-selector mb-3" ref={dropdownRef}>
      <input
        type="text"
        className="form-control form-control-lg inputStyle w-100"
        value={placeholderText}
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen((prev) => !prev);
        }}
        readOnly
      />

      {isOpen && (
        <div
          className="dropdown mt-2 w-100"
          onClick={(e) => e.stopPropagation()}
        >
          {categories.map((category) => (
            <div key={category.id} className="dropdown-item">
              <label
                htmlFor={`checkbox-${category.id}`}
                className="d-flex align-items-center"
                style={{ cursor: "pointer" }}
              >
                <input
                  type="checkbox"
                  id={`checkbox-${category.id}`}
                  checked={selected.includes(category.label)}
                  onChange={() => onChange(category.label)}
                />
                <p className="mb-0 pl-2">{category.label}</p>
              </label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CategoryDropdown;